import { createAction, createAsyncAction } from "typesafe-actions";

import type { SignalEventType } from "app/pages/sales-intelligence/sub-modules/account-overview/company/services/signals/types";
import type { FetchError } from "app/pages/sales-intelligence/types";

import type { TimeGranularity } from "../types/monthly-visits-overtime";
import type { SignalEventDto, SignalEventsDataDto } from "../types/signals";
import type { GeoBreakdownDto } from "../types/visits-geo-breakdown";

export const tldSitesIncludeChangedAction = createAction("@@si/account-overview/tld-sites-include-changed")<boolean>();

export const geoBreakdownTablePageSizeChangedAction = createAction(
    "@@si/account-overview/geo-breakdown-table-page-size-changed",
)<number>();

export const geoBreakdownTableResultsClearedAction = createAction(
    "@@si/account-overview/geo-breakdown-table-results-cleared",
)();

export const visitsOverTimeGranularityChangedAction = createAction(
    "@@si/account-overview/visits-over-time-granularity-changed",
)<TimeGranularity>();

export const visitsOverTimeMonthToDateChangedAction = createAction(
    "@@si/account-overview/visits-over-time-month-to-date-changed",
)();

export const fetchGeoBreakdownTableDataAsync = createAsyncAction(
    "@@si/account-overview/geo-breakdown-table-data-fetch-started",
    "@@si/account-overview/geo-breakdown-table-data-fetch-succeeded",
    "@@si/account-overview/geo-breakdown-table-data-fetch-failed",
)<void, GeoBreakdownDto, FetchError>();

export const fetchSignalEventsAsync = createAsyncAction(
    "@@si/account-overview/signal-events-fetch-started",
    "@@si/account-overview/signal-events-fetch-succeeded",
    "@@si/account-overview/signal-events-fetch-failed",
)<void, SignalEventsDataDto, FetchError>();

export const fetchOtherSignalEventsAsync = createAsyncAction(
    "@@si/account-overview/signal-events-other-fetch-started",
    "@@si/account-overview/signal-events-other-fetch-succeeded",
    "@@si/account-overview/signal-events-other-fetch-failed",
)<void, SignalEventsDataDto, FetchError>();

export const setCompanyEventFilterAction = createAction(
    `@@si/account-overview/set-company-event-filter`,
)<SignalEventType>();

export const setCompanyFilteredSignalEventsAction = createAction(`@@si/account-overview/set-company-signal-events`)<
    readonly SignalEventDto[]
>();

export const toggleCompaniesSelectionAction = createAction(
    "@@si/account-overview/toggle-companies-selection",
)<boolean>();

export const setSelectedCompanyDomainsAction = createAction(`@@si/account-overview/set-selected-company-domains`)<
    Readonly<Set<string>>
>();
